module.exports = __webpack_public_path__ + "static/media/trash.5c509553.svg";